import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { parseUrl } from '@thd-olt-component-react/product-results';

export const useAdditionalSearchParams = ({ pathWithParams, searchNavPropsRef }) => {
  const { cookie, clientStore, customer } = useContext(ExperienceContext);
  const {
    sortby,
    catStyle,
    skipSpellCheck,
  } = parseUrl({ path: pathWithParams });
  const isB2BCustomer = customer.type === 'b2b';

  const hasSponsoredSorts = !sortby || ['bestmatch', 'topsellers'].indexOf(sortby) > -1;
  const additionalSearchParams = {};

  if (cookie?.adobeCookie?.MCMID && searchNavPropsRef.current?.askForSponsored && hasSponsoredSorts) {
    additionalSearchParams.sponsored = true;
    additionalSearchParams.mcvisId = cookie.adobeCookie.MCMID;
  }

  const showProducts = /showproducts/i.test(catStyle);
  if (showProducts) {
    additionalSearchParams.plp = true;
  }

  if (skipSpellCheck) {
    additionalSearchParams.skipSpellCheck = skipSpellCheck;
  }

  if (searchNavPropsRef.current.deliveryZip) {
    additionalSearchParams.deliveryZip = searchNavPropsRef.current.deliveryZip;
  }

  const THDCustomer = typeof window !== 'undefined' && clientStore ? window.THDCustomer?.default : {};
  if (Object.keys(THDCustomer).length !== 0 && THDCustomer.svocID && !isB2BCustomer) {
    additionalSearchParams.svocID = THDCustomer.svocID;
  }

  return additionalSearchParams;
}
